





















import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import PerformanceCustomerCenterOverview from '@/componentsV2/templates/PerformanceCustomerCenterOverview/PerformanceCustomerCenterOverview.vue';
import PerformanceCustomersList from '@/componentsV2/templates/PerformanceCustomersList/PerformanceCustomersList.vue';

import { sleep } from '@/utils';
import { setScrollY } from '@/utils/setScrollY';
import { goToElement } from '@/utils/goToElement';

import flagKeys from '@/constants/flagKeys';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    Page,
    PerformanceCustomerCenterOverview,
    PerformanceCustomersList
  }
})
export default class CustomerCenter extends Vue {
  shouldhHighlightedCard = false;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get editCustomerInactivityIsEnabled() {
    return this.flags.includes(flagKeys.editCustomerInactivity);
  }

  mounted() {
    if (
      window.previousRouteName &&
      window.previousRouteName === 'performance-customer-center-detail'
    ) {
      this.setScrollPosition();

      return;
    }

    if (this.$route.query.customerListFilter) {
      setTimeout(() => {
        goToElement('#customer-relationships-list');
      }, 0);
    } else {
      this.checkShowTutorial();
    }

    this.$store.dispatch('performance/RESET_CONFIG', {
      context: 'customerCenter'
    });
  }

  async checkShowTutorial() {
    if (!this.editCustomerInactivityIsEnabled) return;

    const containerScrollSelector = '.container-scrollable';

    setScrollY(containerScrollSelector, 'hidden');
    await sleep(1000);
    setScrollY(containerScrollSelector, 'auto');

    this.shouldhHighlightedCard = true;
  }

  handleReloadCustomerList() {
    eventBus.$emit('customerCenterReloadCustomers', {
      clearList: true,
      showLoader: false
    });
  }

  handleGoToCustomerList({ filterBy }: { filterBy: string }) {
    eventBus.$emit('preffiledCustomerListFilter', filterBy);

    this.$router.replace({
      query: {
        action: undefined
      }
    });

    setTimeout(() => {
      goToElement('#customer-relationships-list');
    }, 0);
  }

  setScrollPosition() {
    const containerScrollElement = document.querySelector(
      '.container-scrollable'
    );

    const scrollYPos = this.$store.getters['performance/getCustomerCenterState']
      .config.scrollYPos;

    if (containerScrollElement) {
      containerScrollElement.scrollTo({
        top: scrollYPos,
        left: 0
      });
    }
  }
}
